var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getInfoText(_vm.device)),function(state){return _c('v-chip',{key:state,staticClass:"`ma-1 red`",attrs:{"label":""}},[_vm._v(" "+_vm._s(state)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }